import { Button, IconButton, Popover, Typography } from '@prenuvo/halo-foundation';
import { ResetView } from '@prenuvo/halo-icon';

import { api } from '@/api';
import { FCT } from '@/i18n';
import { useStudyGuard } from '@/shared/guard';
import { IS_PROD_ENV } from '@/shared/util';

/**
 * Reset Report Button
 *
 * Temporary button to reset the report to the initial state.
 * This is a temporary solution until we have a proper way to reset the report.
 */
export function ResetReportButton() {
  const { studyId } = useStudyGuard();
  const { mutate: reportMutation } = api.fct.report.mutation.usePatchReport();

  const onResetReport = () => {
    reportMutation(
      {
        payload: {
          status: 'deprecated',
          studyId: studyId!,
        },
      },
      {
        onSuccess: () => {
          window.location.reload();
        },
      },
    );
  };

  if (IS_PROD_ENV) {
    return null;
  }

  return (
    <div>
      <Popover
        trigger={
          <IconButton
            aria-label={FCT.REPORTING.HEADER.ACTIONS.RESET_REPORT}
            className={{ root: 'shrink-0' }}
            data-testid="reset-report-button"
            icon={ResetView}
            size="sm"
            variant="text"
          />
        }
      >
        <Typography as="p">{FCT.REPORTING.HEADER.RESET_REPORT.DESCRIPTION}</Typography>
        <div className="mt-4 flex justify-end">
          <Button onClick={onResetReport} size="sm" variant="outlined">
            {FCT.REPORTING.HEADER.ACTIONS.RESET_REPORT}
          </Button>
        </div>
      </Popover>
    </div>
  );
}
